<div class="inner-addon left-addon input-search" tabindex="-1">
  <svg-icon icon="magnifier" class="bc-search-icon"></svg-icon>
  <input #searchInput [formControl]="searchBox" matInput class="form-control js-search-input"
    placeholder="{{ 'genesysTransferPanelSearch.searchPlaceholder' | translate }}" />
  <span *ngIf="searchBox.value" (click)="searchBox.setValue('')" class="icon fa fa-times-circle js-clear-search-term"></span>
</div>

<div class="search-list">
  <ng-container *ngIf="loading$ | async; else searchList">
    <app-loading></app-loading>
  </ng-container>

  <ng-template #searchList>
    <app-genesys-transfer-panel-search-list
      [keyboardHandlerElement]="elementRef"
      [users]="users$ | async"
      [queues]="queues$ | async"
      [systemPresences]="systemPresences$ | async"
      [canLoadMoreUsers]="canLoadMoreUsers$ | async"
      [canLoadMoreQueues]="canLoadMoreQueues$ | async"
      (loadMoreUsers)="onLoadMoreUsers()"
      (loadMoreQueues)="onLoadMoreQueues()"
      (userSelected)="onUserSelected($event)"
      (queueSelected)="onQueueSelected($event)">
    </app-genesys-transfer-panel-search-list>
  </ng-template>
</div>
